import type { Options } from './interface'

export const options: Options = {
  prerender: true,
  debug: false
}
